import { ApplicationEntityModel } from "src/store/models/entity/application/entity";
import { ApplicationHelperModel } from "src/store/models/entity/application/helper";

export const encooApplicationModels = {
  entity: ApplicationEntityModel,
  helper: ApplicationHelperModel,
};
